<script>
export default {
  name: "WebAbout",
};
</script>

<template>
  <div class="web-about">
    <div class="content-container">
      <div class="card">
        <h1>关于我的</h1>
        <div class="info-block">
          <p>
            如果您有任何问题或想进行交流，请通过以下方式联系我：
          </p>
          <div class="contact-item">
            <span class="icon">📧</span>
            <span class="label">邮箱：</span>
            <a href="mailto:dyuan58@gmail.com" class="link">dyuan58@gmail.com</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.web-about {
  padding: 10px;
  min-height: calc(100vh - 120px);
}

.content-container {
  max-width: 800px;
  margin: 0 auto;
  padding-top: 20px;
}

.card {
  background-color: #1a1d24;
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 12px;
  padding: 40px;
  text-align: left;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

h1 {
  color: #f2f2f2;
  font-size: 24px;
  margin-top: 0;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.info-block {
  color: #b0b0b0;
  font-size: 16px;
  line-height: 1.8;
}

.contact-item {
  display: flex;
  align-items: center;
  margin-top: 20px;
  padding: 16px;
  background-color: rgba(255, 255, 255, 0.02);
  border-radius: 8px;
}

.icon {
  font-size: 20px;
  margin-right: 12px;
}

.label {
  color: #9ca3af;
  margin-right: 8px;
}

.link {
  color: #63a278;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s ease;
}

.link:hover {
  color: #7ab992;
  text-decoration: underline;
}

/* 响应式适配 */
@media (max-width: 768px) {
  .card {
    padding: 24px;
  }

  .contact-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
}
</style>
